import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container } from 'react-bootstrap';
import '../../../../../../styles/diario.scss';
import { Link } from 'react-router-dom';

const mesesNomes = [
    "", "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro", 
    "1ª Parcela - 13º", "2ª Parcela - 13º", "Informe Anual de Rendimentos"
];

const FormBusca = ({ meses, anos, filtrarLocalmente, reset }) => {
    const [mes, setMes] = useState("");
    const [ano, setAno] = useState("");

    const handleMesChange = (e) => {
        const value = e.target.value;
        setMes(value);
        filtrarLocalmente(value, ano);
    };

    const handleAnoChange = (e) => {
        const value = e.target.value;
        setAno(value);
        filtrarLocalmente(mes, value);
    };

    const limpar = () => {
        setMes("");
        setAno("");
        reset(); // volta lista original
    };

    return (
        <Fragment>
            <Row>
                <Col xs={6} lg={4}>
                    <Form.Group controlId="selectMes">
                        <FloatingLabel label="Mês">
                            <Form.Select value={mes} onChange={handleMesChange}>
                                <option value="">Todos</option>
                                {meses.map(m => (
                                    <option key={m} value={m}>
                                        {mesesNomes[m]}
                                    </option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <Col xs={6} lg={4}>
                    <Form.Group controlId="selectAno">
                        <FloatingLabel label="Ano">
                            <Form.Select value={ano} onChange={handleAnoChange}>
                                <option value="">Todos</option>
                                {anos.map(a => (
                                    <option key={a} value={a}>{a}</option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>
                    </Form.Group>
                </Col>
                <br/>
                <Col xs={6} lg={2}>
                    <Button variant="danger" className="w-100 botao-alto" onClick={limpar}>
                        Limpar
                    </Button>
                </Col>
                <Col xs={6} lg={1}>
                    <Link to={'/rh/funcionarios/listar'}>
                        <Button variant="danger" className='botao-alto' type="button">
                            Voltar
                        </Button>
                    </Link>
                </Col>
            </Row>
        </Fragment>
    );
};


export default FormBusca
